import { connect } from 'react-redux'
import desksSelector from './desksSelector'
import { sagaActions } from '../../sagas'
import Desks from './Desks'

export default connect(
  desksSelector,
  {
    requestAddLayoutTemplateFromFile: sagaActions.requestAddLayoutTemplateFromFile,
  }
)(Desks)
